import {Dispatch} from 'react';
import {AppThunk} from '../rootReducer';

export const SHOW_LOADER = 'SHOW_LOADER';

export const HIDE_LOADER = 'HIDE_LOADER';

interface ShowLoaderAction {
    type: typeof SHOW_LOADER
}

interface HideLoaderAction {
    type: typeof HIDE_LOADER
}

export interface LoaderState {
    waitCount: number,
    show: boolean
}

export type LoaderActionTypes = ShowLoaderAction | HideLoaderAction;

export const showLoader = (): AppThunk => {
    return (dispatch: Dispatch<ShowLoaderAction>) => {
        return dispatch({
            type: SHOW_LOADER
        });
    };
};

export const hideLoader = (): AppThunk => {
    return (dispatch: Dispatch<HideLoaderAction>) => {
        return dispatch({
            type: HIDE_LOADER
        });
    };
};

